import { render } from "./edit-pencil.vue?vue&type=template&id=4dae34f0"
const script = {}

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__